import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateProductByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Products_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdateProductByIdMutation = { __typename?: 'mutation_root', update_products_by_pk?: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, created_at?: any | null, updated_at?: any | null, extended_price?: any | null, retail_price?: any | null, workspace_id?: any | null, photo_link?: string | null, product_category: { __typename?: 'product_categories', name: string, label: string }, product_attachments: Array<{ __typename?: 'product_attachments', id: any, product_id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, description?: string | null, name?: string | null, created_at: any, updated_at: any }>, workspace?: { __typename?: 'workspaces', id: any, name: string, logo?: string | null, public: boolean, partitionId?: string | null } | null } | null };


export const UpdateProductByIdDocument = gql`
    mutation updateProductById($set: products_set_input, $id: uuid!) {
  update_products_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    name
    description
    sku
    product_category {
      name
      label
    }
    make
    model
    created_at
    updated_at
    extended_price
    retail_price
    workspace_id
    photo_link
    product_attachments {
      id
      product_id
      photo_link
      document_link
      video_link
      audio_link
      site_link
      transcription
      transcribed
      type
      description
      name
      created_at
      updated_at
    }
    workspace {
      id
      name
      logo
      public
      partitionId
    }
  }
}
    `;
export type UpdateProductByIdMutationFn = Apollo.MutationFunction<UpdateProductByIdMutation, UpdateProductByIdMutationVariables>;

/**
 * __useUpdateProductByIdMutation__
 *
 * To run a mutation, you first call `useUpdateProductByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductByIdMutation, { data, loading, error }] = useUpdateProductByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateProductByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductByIdMutation, UpdateProductByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductByIdMutation, UpdateProductByIdMutationVariables>(UpdateProductByIdDocument, options);
      }
export type UpdateProductByIdMutationHookResult = ReturnType<typeof useUpdateProductByIdMutation>;
export type UpdateProductByIdMutationResult = Apollo.MutationResult<UpdateProductByIdMutation>;
export type UpdateProductByIdMutationOptions = Apollo.BaseMutationOptions<UpdateProductByIdMutation, UpdateProductByIdMutationVariables>;